import * as yup from 'yup'
import { courseSchema } from './courseSchema';
import { universitySchema } from './universitySchema';
import { specializationSchema } from './specializationSchema';
import { admissionSchema } from './admissionSchema';

const validationObj = {
  university: universitySchema,
  course: courseSchema,
  specialization:specializationSchema,
  admission:admissionSchema
};

export const validateSchema = async (values, type) => {
  try {
    let fieldObj = {};
    if(Array.isArray(values)){
      values?.forEach((item) => {
        fieldObj[item?.id] = item?.value;
      });
    }else if(typeof values ==="object"){
      fieldObj = values
    }else{
      return 
    }

    const schema = validationObj[type];
    if (!schema) return null;

    await schema.validate(fieldObj, { abortEarly: false });

    return { valid: true, errors: {} };
  } catch (error) {
    console.log("error",error);
    
    if (error.inner) {
      const errors = {};
      error.inner.forEach((err) => {
        if (!errors[err.path]) {
          errors[err.path] = err.message;
        }
      });
      return { valid: false, errors };
    }
    return { valid: false, errors: { general: "Validation failed" } };
  }
};

